(ns practitest.frontend.pt-ts-bridge
  (:require ["/pt_ts.js" :as pt-ts-dev]
            ["ts-components" :as pt-ts-prod]
            [practitest.frontend.common.utils :as utils]))


(def ^:private module (if (utils/in-dev-mode?) pt-ts-dev pt-ts-prod))

(def Button (.-Button module))
(def GenericSearchableTree (.-GenericSearchableTree module))
(def FormLayoutWrapper (.-FormLayoutWrapper module))
(def TranslationProvider (.-TranslationProvider module))
(def FiltersPanel (.-FiltersPanel module))
(def ConfirmationModal (.-ConfirmationModal module))
(def DeletionPreventionModal (.-DeletionPreventionModal module))
(def Loading (.-Loading module))
(def ConflictItem (.-ConflictItem module))

(def ComponentsProvider (.-ComponentsProvider module))
(def IconsProvider (.-IconsProvider module))